import React from "react";
import "./404page.style.sass";
import BG from "../../assets/image/design1.png";

const Page404 = () => {
	return (
		<div className="page404">
			<h3 className="page404-title">404 صفحه مورد نظر یافت نشد</h3>
			<img
				src={BG}
				alt="xitonix satellite"
			/>
		</div>
	);
};

export default Page404;
